import styled from '@tanium/react-emotion';
import { css } from '@tanium/style-system';
import { ThemeFontWeights } from '@tanium/theme-data';
import { DescriptionText } from './themeDefinitions';

export const DefinitionDescription = styled('dd')(
  css({ color: DescriptionText, display: 'table-cell', fontWeight: ThemeFontWeights.Bold }),
);
